import { render, staticRenderFns } from "./AggregatedReportSettings.vue?vue&type=template&id=66c044dc&"
import script from "./AggregatedReportSettings.vue?vue&type=script&lang=js&"
export * from "./AggregatedReportSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports